import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-beaker",
  templateUrl: "./beaker.component.html",
  styleUrls: ["./beaker.component.scss"],
})
export class BeakerComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
